export const pineappleLabsTitle = ' | Pineapple Labs';
